import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/calendar_icon.svg'
import _imports_1 from '@/assets/img/users_icon.svg'
import _imports_2 from '@/assets/img/suitcase_icon.svg'


const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Aqui você poderá escolher qual é a melhor forma para atender seus pacientes. ", -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0 ms-3" }, "Sessões agendadas")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Baseado nos horários disponíveis da sua agenda, os pacientes irão solicitar agendamento. Você receberá uma notificação e terá as opções de aceitar ou cancelar. ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-paragraph" }, "Valor fixo por sessão", -1)
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "mb-0 text-paragraph me-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-paragraph" }, "Meus horários", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right" }, null, -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_18 = { class: "d-flex justify-content-between align-items-center pb-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-paragraph" }, "Disponível agora", -1)
const _hoisted_20 = { class: "card" }
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0 ms-3" }, "Conversa inicial")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Permitir que a primeira sessão com um novo paciente tenha um valor diferenciado para ambos se conhecerem antes de iniciarem um tratamento juntos. ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_26 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-paragraph" }, "Valor fixo por sessão", -1)
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = { class: "mb-0 text-subtitle me-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 text-paragraph" }, "Editar valor", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right" }, null, -1)
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = { class: "card" }
const _hoisted_35 = { class: "card-body" }
const _hoisted_36 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("p", { class: "text-header mb-0 ms-3" }, "Desconto para empresas")
], -1)
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<p class=\"text-paragraph\"> Ao ativar esta função, você se tornará visível para os funcionários das empresas parceiras do Psiapp, que oferecem até 30% de desconto em sessões como um benefício para os pacientes. </p><hr class=\"my-4\"><div class=\"d-flex justify-content-between align-items-center pb-3\"><p class=\"mb-0 text-paragraph\">Desconto nas sessões</p><p class=\"mb-0 text-subtitle\">Até 30%</p></div>", 3)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwitchInput = _resolveComponent("SwitchInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_SwitchInput, {
            id: _ctx.settingsType.block_agenda,
            color: "secondary",
            checked: !_ctx.session?.block_agenda,
            onHandleChange: _cache[0] || (_cache[0] = ($event: any) => (
              _ctx.updateAvailabilitySettings(_ctx.settingsType.block_agenda)
            )),
            loading: _ctx.settingsLoading.block_agenda
          }, null, 8, ["id", "checked", "loading"])
        ]),
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", {
          class: "d-flex justify-content-between align-items-center cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleNavigation(_ctx.views.appointment_price)))
        }, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(`R$${_ctx.session?.appointment_price}`), 1),
            _hoisted_12
          ])
        ]),
        _hoisted_13,
        _createElementVNode("div", {
          class: "d-flex justify-content-between align-items-center cursor-pointer",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleNavigation(_ctx.views.schedule_info)))
        }, _hoisted_16),
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_SwitchInput, {
            id: _ctx.settingsType.online,
            color: "secondary",
            checked: _ctx.session?.online,
            onHandleChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateAvailabilitySettings(_ctx.settingsType.online))),
            loading: _ctx.settingsLoading.online
          }, null, 8, ["id", "checked", "loading"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode(_component_SwitchInput, {
            id: _ctx.settingsType.first_appointment,
            color: "secondary",
            checked: _ctx.session?.first_appointment,
            onHandleChange: _cache[4] || (_cache[4] = ($event: any) => (
              _ctx.updateAvailabilitySettings(_ctx.settingsType.first_appointment)
            )),
            loading: _ctx.settingsLoading.first_appointment
          }, null, 8, ["id", "checked", "loading"])
        ]),
        _hoisted_24,
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("p", _hoisted_29, _toDisplayString(`R$${
                  _ctx.session?.first_appointment_price
                    ? _ctx.session?.first_appointment_price
                    : _ctx.session?.appointment_price
                }`), 1)
          ])
        ]),
        _hoisted_30,
        _createElementVNode("div", {
          class: "d-flex justify-content-between align-items-center pb-3 cursor-pointer",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleNavigation(_ctx.views.appointment_price)))
        }, _hoisted_33)
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createVNode(_component_SwitchInput, {
            id: _ctx.settingsType.partnerships,
            color: "secondary",
            checked: _ctx.session?.partnerships,
            onHandleChange: _cache[6] || (_cache[6] = ($event: any) => (
              _ctx.updateAvailabilitySettings(_ctx.settingsType.partnerships)
            )),
            loading: _ctx.settingsLoading.partnerships
          }, null, 8, ["id", "checked", "loading"])
        ]),
        _hoisted_38
      ])
    ])
  ]))
}